import {
  useEffect
} from 'react'
import {
  OnboardingEvents,
  trackEvent
} from '../analytics/posthog'
import type {
  PresignupAssistantChoice
} from '../utils/presignupAssistant'
import {
  CharacterSelectionStep
} from './onboarding/CharacterSelectionStep'

interface PresignupAssistantPickerProps {
  onChoose: (choice: PresignupAssistantChoice, assistantName: string) => void
  onSkipToLogin: () => void
}

/**
 * The 'test' arm of presignup-assistant-picker (GET-18726): a signed-out
 * visitor meets their assistant before the sign-in buttons. The wizard's own
 * step does the picking; nothing is saved until there is an account.
 */
export function PresignupAssistantPicker({
  onChoose,
  onSkipToLogin,
}: PresignupAssistantPickerProps): JSX.Element {
  useEffect(() => {
    trackEvent(OnboardingEvents.PRESIGNUP_PICKER_VIEWED)
  }, [])

  return (
    <div className="min-h-dvh bg-catch-beige flex items-center justify-center px-4 py-10">
      <div className="max-w-2xl w-full bg-catch-white rounded-2xl shadow-soft-lg p-6 sm:p-10">
        <CharacterSelectionStep onChoose={onChoose} />
        <p className="mt-6 text-center text-sm text-catch-black/55">
          Already have an account?{' '}
          <button
            onClick={onSkipToLogin}
            className="underline underline-offset-2 hover:text-catch-black transition-colors"
          >
            Log in
          </button>
        </p>
      </div>
    </div>
  )
}
